import React from 'react';

import { IProduct } from '../../../../InvoiceCreation/types/types';

export const descriptionTemplate = (product: IProduct) => (
  <div>
    <div className='flex items-center   max-w-[50ch]'>
      <p className='font-metricR text-[16px] text-bw08 truncate max-w-full' title={product.description || '-'}>
        {product.description || '-'}
      </p>
    </div>
  </div>
);
